import { footerConstants as fc } from 'srcReact/Footer'
import { userService } from 'srcReact/services'

export const footerActions = {
  subscribeNewsletter,
}

function subscribeNewsletter(email) {
  return (dispatch) => {
    dispatch(request({ email }))

    userService.subscribeNewsletter(email).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: fc.SUBSCRIBE_NEWSLETTER_REQUEST, response }
  }
  function success(response) {
    return { type: fc.SUBSCRIBE_NEWSLETTER_SUCCESS, response }
  }
  function failure(error) {
    return { type: fc.SUBSCRIBE_NEWSLETTER_FAILURE, error }
  }
}
